import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AutenticacionService {

  constructor(private _http: HttpClient) { }

  login(email: string, contrasena: string): Observable<LoginResponse> {
    let url = 'https://as-ws-siteit-test.azurewebsites.net/api/users/login';
    let passwordEnc = CryptoJS.SHA256(contrasena).toString(CryptoJS.enc.Hex);

    let headers = new HttpHeaders({
        'loginType': 'username'
    });

    return <Observable<LoginResponse>> this._http.post(url, {
      'username': email,
      'password': passwordEnc
   }, { headers });
  }

  cerrarSesion() {
    localStorage.removeItem("data_login");
  }

  recuperarContrasena(email: string) {
    const url = "https://as-ws-siteit-test.azurewebsites.net/api/users/recovery";
    
    return <Observable<LoginResponse>> this._http.post(url, {
      email,
   }); 
  }

  cambiarContrasena(contrasena: string, token: string) {
    const url = "https://as-ws-siteit-test.azurewebsites.net/api/users/recovery";
    let passwordEnc = CryptoJS.SHA256(contrasena).toString(CryptoJS.enc.Hex);

    return <Observable<LoginResponse>> this._http.put(url, {
      user_password: passwordEnc,
      token
    }); 
  }

  public get dataLogin(): DataLogin  {
    return JSON.parse(localStorage.getItem('data_login'));
  }
}

export interface LoginResponse {
  ok: boolean,
  response: {
    data_login: DataLogin
  },
  message: string
}

export interface DataLogin {
  token: string,
  user_id: number,
  company_id: number,
  company_longitude: string,
  company_latitude: string,
  company_type: number,
  role: string,
  vertical_id: number
}